import { Description, Edit, Print } from "@mui/icons-material";
import { Box } from "@mui/material";
import useApi from "_api/index";
import { BackButton } from "components/Button";
import Actions from "components/Car/Actions";
import FormDocumentList from "components/Car/FormDocumentList";
import ModalContractPawnCar from "components/Modal/Car/FormDocuments/ContractPawn";
import ModalPowerOfAttorney from "components/Modal/Car/FormDocuments/PowerOfAttorney";
import ModalCreateTransferAndReceiptBuy from "components/Modal/Car/FormDocuments/TransferAndReceiptBuy";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const FormPawnCars = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isPowerOfAttorneyModalOpen, setIsPowerOfAttorneyModalOpen] =
    useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      console.error("ID is not provided");
      return;
    } else {
      fetchData();
    }
  }, [id]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.pawn_car.getPawnCarById(id);
      if (response.success) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintPDF = async (document) => {
    let response = null;
    try {
      if (document.document_type === "car_pawn_contact") {
        response = await useApi.pawn_car.printPdfCarPawnContact(
          document.document_id
        );
      } else if (document.document_type === "car_transform") {
        response = await useApi.pawn_car.printPdfCarTransferPawn(
          document.document_id
        );
      } else if (document.document_type === "car_power_of_attorney") {
        response = await useApi.pawn_car.printPdfPowerOfAttorneyPawn(
          document.document_id
        );
      }

      if (response && response.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <>
      <FormDocumentList
        car={data ? data.car : null}
        type="pawn_car"
        loading={loading}
        columns={[
          { key: "document", label: "ฟอร์มเอกสาร" },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "right",
            },

            render: (row) => {
              const findCreated = data
                ? data.documents?.some(
                    (doc) => doc.document_type === row.document_type
                  )
                : false;
              const findDocument = data
                ? data.documents?.find(
                    (doc) => doc.document_type === row.document_type
                  )
                : null;
              return (
                <Actions
                  menuList={[
                    {
                      label: findCreated ? "แก้ไขเอกสาร" : "สร้างเอกสาร",
                      icon: findCreated ? <Edit /> : <Description />,
                      onClick: () => {
                        setSelectedRow(findDocument);
                        if (row.document_type === "car_pawn_contact") {
                          setIsModalOpen(true);
                        } else if (row.document_type === "car_transform") {
                          setIsTransferModalOpen(true);
                        } else if (
                          row.document_type === "car_power_of_attorney"
                        ) {
                          setIsPowerOfAttorneyModalOpen(true);
                        }
                      },
                    },
                    findCreated && {
                      label: "พิมพ์เอกสาร",
                      icon: <Print />,
                      onClick: () => {
                        handlePrintPDF(findDocument);
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
        data={[
          {
            id: 1,
            document: "สัญญาจำนำ",
            document_type: "car_pawn_contact",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
        ]}
      />
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
        <BackButton onClick={() => navigate("/car/pawn_cars")} />
      </Box>

      <ModalContractPawnCar
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedRow(null);
        }}
        data={data ? data : null}
        document={selectedRow ? selectedRow : null}
        onSuccess={() => {
          setIsModalOpen(false);
          fetchData();
        }}
      />

      <ModalCreateTransferAndReceiptBuy
        isOpen={isTransferModalOpen}
        onClose={() => {
          setIsTransferModalOpen(false);
          setSelectedRow(null);
        }}
        car={data ? data.car : null}
        order={
          data
            ? {
                order_id: data.order_id,
              }
            : null
        }
        customer={data ? data.customer : null}
        document={selectedRow ? selectedRow : null}
        type="pawn_car"
        onSuccess={() => {
          setIsTransferModalOpen(false);
          fetchData();
        }}
      />

      <ModalPowerOfAttorney
        isOpen={isPowerOfAttorneyModalOpen}
        onClose={() => {
          setIsPowerOfAttorneyModalOpen(false);
          setSelectedRow(null);
        }}
        car={data ? data.car : null}
        order={
          data
            ? {
                order_id: data.order_id,
              }
            : null
        }
        customer={data ? data.customer : null}
        document={selectedRow ? selectedRow : null}
        type="pawn_car"
        onSuccess={() => {
          setIsPowerOfAttorneyModalOpen(false);
          fetchData();
        }}
      />
    </>
  );
};

export default FormPawnCars;
